// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2UT0d","sendOtp":"AuthorizeToLogin_sendOtp__VTiO0"};